import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const postExchangeShop = async (payload) => {
  const response = await axiosInstance.post(API_ROUTES.ExchangeItem, payload)
  return response.data
}
